import { useEffect } from 'react';
import { scheduleGoogleAnalytics } from '@/lib/analytics';

/** Laadt GA alleen na cookie-consent, uitgesteld via requestIdleCallback. */
export function GoogleAnalytics() {
  useEffect(() => {
    if (localStorage.getItem('cookie-consent') === 'accepted') {
      scheduleGoogleAnalytics();
    }
  }, []);

  return null;
}
